import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { transform_languages, CREDIT_COST } from "../../components/Transformation/Transformations";
import { Rating } from "@material-tailwind/react";
import '../../components/Cards/activelingo.css';

export default function ActiveLingoCard(props) {
  const navigation = useNavigate();
  const { t } = useTranslation();

  const viewLeader = () => {
    const leaderId = props?.id;
    navigation(`/leaders/profile/${leaderId}`);
  };

  const formatReviewCount = (count) => {
    if (!count) return "No Counts yet";
    if (count >= 1000) {
      return `(${(count / 1000).toFixed(1)} k Reviews)`;
    }
    return `(${count} reviews)`;
  };

  const formatReviewScore = (count) => {
    if (!count) return "No Score yet";
    return `${count.toFixed(1)}`;
  };

  return (
    <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-8 bg-white border border-[var(--border)] rounded-[var(--radius)] p-6 shadow-[var(--shadow-sm)] my-auto lg:my-0 mx-auto w-full lg:mx-0 max-w-[400px] sm:max-w-[480px] lg:max-w-full hover:shadow-[var(--shadow)] hover:-translate-y-1 transition-all">
      <img
        src={
          props.image ||
          "https://res.cloudinary.com/do6t8sxgo/image/upload/v1724686661/Nobody_bao3i5.svg"
        }
        alt="ActivityLingoLeader"
        className="w-[120px] md:w-[150px] object-cover h-[120px] md:h-[150px] border-2 border-[var(--brand)] rounded-full cursor-pointer"
        onClick={viewLeader}
      />
      <div className="text-center sm:text-left flex-1">
        <h3
          onClick={viewLeader}
          className="text-xl md:text-2xl font-bold cursor-pointer mb-1 text-[var(--text)] hover:text-[var(--brand)] transition-colors"
        >
          {props.name}
        </h3>

        <h5 className="text-sm font-semibold text-[var(--text)]">
          {t("active_lingo_card.teaching")}{" "}{t(transform_languages(props.teaching_language))}
        </h5>
        <h5 className="text-sm text-[var(--muted)]">
          {t("active_lingo_card.also_speak")}:{" "}{props.also_speak}
        </h5>
        <h5 className="text-sm font-semibold text-[var(--text)] mt-1">
            {props.credit_adjustment_rate === 0 ? (
              <span className="text-[var(--accent)] font-bold"> ({t("active_lingo_card.free")}) </span>
            ) : <span className="text-[#22C55E] font-bold"> ${(props.credit_adjustment_rate * CREDIT_COST / 4.0).toFixed(2)} {t("active_lingo_card.unit")} </span>
            }
        </h5>
        <div className="mt-3">
          <Rating value={Math.round(props?.reviewScore) || 0} readonly />
          <p className="flex gap-2 justify-center sm:justify-start text-[var(--brand)] items-center text-sm">
            {formatReviewScore(props?.reviewScore)}
            <span className="text-[var(--muted)] text-sm">
              {formatReviewCount(props?.reviewCount)}
            </span>
          </p>
        </div>
        <button
          className="mt-4 bg-[var(--brand)] w-[180px] h-9 rounded-full text-white text-sm font-semibold shadow-[0_4px_14px_rgba(108,99,255,.3)] hover:bg-[var(--brand-dark)] hover:-translate-y-[1px] transition-all"
          onClick={viewLeader}
        >
          {t("active_lingo_card.request_meeting_button")}
        </button>
      </div>
    </div>
  );
}
